import { render, staticRenderFns } from "./CustomKeywordRuleRow.vue?vue&type=template&id=44088c74&scoped=true"
import script from "./CustomKeywordRuleRow.vue?vue&type=script&lang=js"
export * from "./CustomKeywordRuleRow.vue?vue&type=script&lang=js"
import style0 from "./CustomKeywordRuleRow.vue?vue&type=style&index=0&id=44088c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44088c74",
  null
  
)

export default component.exports